<template>
    <div>
        <iframe style="width:100vw;height:100vh;" frameborder="0" scrolling="no" :src="pdfPath"></iframe>
    </div>
</template>
<script>
    export default {
        name:'warrantyView',
        data() {
            return {
                pdfPath: '../static/docs/product_warranty.pdf'
            };
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/hanscourse/warranty/warrantyView.vue